import React from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

export const FullScreenExitIcon = (props: SvgIconProps) => (
  <SvgIcon
    width="28"
    height="28"
    viewBox="0 0 28 28"
    fill="none"
    sx={{ fill: 'none' }}
    {...props}
  >
    <path
      d="M10 4H5C4.44772 4 4 4.44772 4 5V10"
      stroke="white"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M24 10L24 5C24 4.44772 23.5523 4 23 4L18 4"
      stroke="white"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M18 24L23 24C23.5523 24 24 23.5523 24 23L24 18"
      stroke="white"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M4 18L4 23C4 23.5523 4.44772 24 5 24L10 24"
      stroke="white"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <rect
      opacity="0.2"
      x="9"
      y="9"
      width="10"
      height="10"
      rx="1"
      fill="white"
    />
  </SvgIcon>
);
